module.exports = __webpack_public_path__ + "img/cashbuddy@2x.3e2df15.png";